import axios from '@/api/axios';
import Vapi from 'vuex-rest-api';

const store = new Vapi({
  axios,
  state: {
  },
})
  .get({
    action: 'getOrders',
    path: '/shop/orders',
  })
  .put({
    action: 'getAggregatedOrders',
    path: '/shop/orders/aggregated',
  })
  .put({
    action: 'getOrdersList',
    path: '/shop/orders/list',
  })
  .post({
    action: 'getOrdersReport',
    requestConfig: {
      responseType: 'blob',
    },
    path: '/shop/orders/report',
  })
  .post({
    action: 'updateOrders',
    path: () => '/shop/orders',
  })
  .put({
    action: 'removeOrdersFromReserveQueue',
    path: () => '/shop/orders/reserve-remove',
  })
  .put({
    action: 'moveOrdersToReserveQueue',
    path: () => '/shop/orders/reserve-add',
  })
  .put({
    action: 'promoteOrdersFromReserveQueue',
    path: () => '/shop/orders/reserve-promote',
  })
  .get({
    action: 'getOrdersAudit',
    path: () => '/shop/orders/audit',
  })
  .put({
    action: 'updateOrderItems',
    path: '/shop/orders/items',
  })
  .put({
    action: 'setCatalogOrdersLayout',
    path: ({ catalogId }) => `/shop/catalogs/${catalogId}/layout/orders`,
  })
  .getStore();

export default store;
